var map = {
	"./ic-deals-inactive.svg": 5252,
	"./ic-departments-inactive.svg": 7172,
	"./ic-favorites-inactive.svg": 2734,
	"./ic-featured-inactive.svg": 6963,
	"./ic-home-inactive.svg": 6014,
	"./ic-menu-inactive.svg": 6474,
	"./ic-popular-inactive.svg": 1182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3273;